import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'apc-modal-confirm-action',
    templateUrl: './modal-confirm-action.component.html',
    styleUrls: ['./modal-confirm-action.component.scss'],
    standalone: false
})
export class ModalConfirmActionComponent {

  @Input() message: string;

  constructor(public activeModal: NgbActiveModal) {}

  close() {
    this.activeModal.close(false);
  }

  confirm() {
    this.activeModal.close(true);
  }

}
